export default __webpack_public_path__ + "static/media/img5.161b2116.svg";